import React from "react";
import { ChevronDown } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function IndustryOverview() {
  const {
    ref: sectionRef,
    isVisible
  } = useRevealOnScroll();
  return <section data-section-id="36909" id="hero-introduction" ref={sectionRef} className="relative min-h-[85vh] flex items-center justify-center overflow-hidden bg-secondary">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/homestead_property.png)] bg-cover bg-center opacity-100" />
        {}
        <div className="absolute inset-0 bg-secondary/60 mix-blend-multiply" />
        <div className="absolute inset-0 bg-transparent" /> {}
      </div>

      {}
      <div className="relative z-10 container mx-auto px-4 text-center">
        <div className={`transition-all duration-1000 ease-out transform ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
          {}
          <span className="inline-block text-primary font-mono text-sm md:text-base tracking-[0.2em] uppercase mb-6 font-medium">
            Certified Professional Inspections
          </span>

          {}
          <h1 className="font-sans font-extrabold text-white text-5xl md:text-7xl lg:text-8xl tracking-[-0.02em] mb-8 leading-[1.1] uppercase">
            HOME INSPECTION IN HOMESTEAD, FL
          </h1>

          {}
          <p className="font-sans text-white/90 text-lg md:text-xl max-w-[700px] mx-auto mb-10 leading-[1.6] font-medium">
            Trusted Inspections provides visual home inspections, condo inspections, wind mitigation, 4-point inspections, mold testing, thermal imaging, and sewer camera inspections for buyers, sellers, homeowners, and realtors in Homestead and surrounding South Florida areas. Our certified experts deliver detailed property evaluation and detailed reports to protect your investment.
          </p>

          {}
          <div className="flex justify-center">
            <Button asChild className="bg-primary text-primary-foreground hover:bg-primary/90 hover:text-primary-foreground rounded-[6px] px-8 py-6 text-base font-semibold tracking-wide transition-all duration-300 shadow-lg shadow-primary/20 border-t border-white/10">
              <Link to="/ServiceAndLocationPage">
                SCHEDULE INSPECTION
              </Link>
            </Button>
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <ChevronDown className="w-8 h-8 text-primary opacity-80" />
      </div>
    </section>;
}